<template>
    <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 id="tituloPainel" class="card-dados__titulo mb-0">Listagem</h3>

        <v-data-table :headers="headersTabela" :items="value" hide-actions
                      class="az-table-list tabela-itens">
            <template slot="items" slot-scope="props">
                <td>
                    {{ props.item.identificacaoSequencial }}
                </td>
                <td>
                    {{ props.item.codigo }}
                </td>
                <td ref="coluna_descricao">
                    <expansao-texto :tamanho="tamanho" :texto="props.item.descricao"/>
                </td>
                <td>
                    <v-tooltip top v-if="props.item.motivo" class="botao-motivo">
                        <a slot="activator">
                            {{ props.item.situacao | azEnum(situacoesItensELotes) }}
                            <i class="fas fa-comment" aria-hidden="true"/>
                        </a>
                        {{ props.item.motivo }}
                    </v-tooltip>
                    <span v-else>
                        {{ props.item.situacao | azEnum(situacoesItensELotes) }}
                    </span>
                </td>
                <td>
                    {{ props.item.porteExclusivo ? 'Sim' : 'Não' }}
                </td>
                <td align="right">
                    {{ props.item.unidade }}
                </td>
                <td align="right">
                    {{ props.item.quantidade | cdCurrency('', qtdeCasasDecimais(casasDecimaisQuantidade)) }}
                </td>
                <td v-if="possuiValorReferencia" align="right">
                    {{ props.item.valorEstimado | cdCurrency(prefix, casasDecimais) }}{{suffix}}
                </td>
                <td v-if="possuiValorReferencia && !isCriterioJulgamentoMaiorDesconto" align="right">
                    {{ props.item.totalEstimado | cdCurrency(prefix, casasDecimais) }}{{suffix}}
                </td>
            </template>
        </v-data-table>

        <div class="total total-mobile" v-if="possuiValorReferencia && !isCriterioJulgamentoMaiorDesconto && value.length > 1">
            <p>
                <strong>Total:</strong> {{ total | cdCurrency(prefix, casasDecimais) }}{{suffix}}
            </p>
        </div>
    </v-flex>
</template>

<script>
import {situacoesItensELotes} from '@/core/constants'
import {mapState} from 'vuex'

export default {
    name: 'PainelItemVisualizacao',
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        possuiValorReferencia: {
            type: Boolean,
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        prefixOuSuffixValor:{
            type: String
        },
        criterioJulgamento:{
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            tamanho: null,
            situacoesItensELotes
        }
    },
    computed: {
        ...mapState(['loki']),
        total() {
            let total = 0
            this.value.forEach(item => {
                if (item.totalEstimado > 0) {
                    total += item.totalEstimado
                }
            })
            return total
        },
        prefix(){
            return this.prefixOuSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixOuSuffixValor === '%' ? '%' : ''
        },
        headersTabela(){
            return [
                {
                    text: 'Seq',
                    sortable: true,
                    align: 'left',
                    width: '5%',
                    class: 'primary--text',
                    value: 'sequencia'
                },
                {
                    text: 'Código',
                    align: 'left',
                    value: 'codigo',
                    width: '5%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    align: 'left',
                    text: 'Descrição',
                    value: 'descricao',
                    width: '30%',
                    class: 'primary--text',
                    sortable: false
                },
                {
                    text: 'Situação',
                    sortable: false,
                    value: 'situacao',
                    align: 'left',
                    width: '10%',
                    class: 'primary--text'
                },
                {
                    text: 'Exclusivo',
                    sortable: false,
                    width: '5%',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    text: 'Unidade',
                    value: 'unidade',
                    sortable: false,
                    align: 'right',
                    width: '8%',
                    class: 'primary--text'
                },
                {
                    text: 'Qtd',
                    value: 'quantidade',
                    sortable: false,
                    align: 'right',
                    width: '5%',
                    class: 'primary--text'
                },
                ... this.possuiValorReferencia ? [{
                    value: 'valorEstimado',
                    text:  this.isCriterioJulgamentoMaiorDesconto ? 'Estimado Unit. (%)' : 'Estimado Unit. (R$)',
                    sortable: false,
                    align: 'right',
                    width: '10%',
                    class: 'primary--text'
                }] : [],
                ... this.possuiValorReferencia && !this.isCriterioJulgamentoMaiorDesconto ? [{
                    value: 'totalEstimado',
                    text: 'Estimado Total (R$)',
                    align: 'right',
                    width: '10%',
                    sortable: false,
                    class: 'primary--text'
                }] : [],
            ]
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    },
    methods: {
        pegarTamanho() {
            this.tamanho = 0.082 * window.innerWidth
        }
    }
}
</script>

<style scoped lang="stylus">
    .tabela-itens, .tabela-itens-manual
        padding 16px

    @media (max-width 720px)
        .tabela-itens, .tabela-itens-manual
            padding 0

            td:nth-of-type(1):before
                content "Sequência:"

            td:nth-of-type(6)
                text-align left

            td:nth-of-type(7)
                text-align left

            td:nth-of-type(8)
                text-align left

        .tabela-itens
            td:nth-of-type(2):before
                content "Código:"

            td:nth-of-type(3):before
                content "Descrição:"

            td:nth-of-type(4):before
                content "Situação:"

            td:nth-of-type(5):before
                content "Exclusivo:"

            td:nth-of-type(6):before
                content "Unidade:"

            td:nth-of-type(7):before
                content "Quantidade:"

            td:nth-of-type(8):before
                content "Estimado Unitário (R$):"

            td:nth-of-type(9):before
                content "Estimado Total (R$):"

            td:nth-of-type(9)
                text-align left

        .tabela-itens-manual
            td:nth-of-type(2):before
                content "Descrição:"

            td:nth-of-type(3):before
                content "Situação:"

            td:nth-of-type(4):before
                content "Exclusivo:"

            td:nth-of-type(5):before
                content "Unidade:"

            td:nth-of-type(6):before
                content "Quantidade:"

            td:nth-of-type(7):before
                content "Estimado Unitário (R$):"

            td:nth-of-type(8):before
                content "Estimado Total (R$):"

            td:nth-of-type(5)
                text-align left
</style>
